import React from 'react'
import { SetupProfileForm, LoadingSetupProfileForm } from '@/features'
import { useGetMe } from '@/domain/identity/useCases/useGetMe'

export const SetupProfileScreen: React.FC = () => {
  // In the original there is an email_confirmed check, but for simplicity we assume email is already confirmed
  const { data: myProfile, isLoading: isLoadingProfile } = useGetMe()

  const hasEmailAlreadyVerified = !!myProfile?.email_confirmed
  if (!myProfile && isLoadingProfile) {
    return <LoadingSetupProfileForm />
  }

  return <SetupProfileForm hasEmailAlreadyVerified={hasEmailAlreadyVerified} />
}
